import React, { useEffect, useState } from "react";
import { TailSpin, ThreeDots } from "react-loader-spinner";
import BaseLayout from "../../layout/BaseLayout";
import Snackbar from "@mui/material/Snackbar";
import Pagination from "@mui/material/Pagination";
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import {
  ajoutNiveauEtude,
  deleteNiveauEtude,
  getListeNiveauEtudePagination,
} from "../../services/niveau-etude/NiveauEtudeRequest";
import { getListeCategorie, getListeNiveauParCategorie } from "../../services/categorie/CategorieRequest";
import { useNavigate } from "react-router-dom";

const NiveauEtude = () => {
  const navigate = useNavigate();
  const [pageQuery, setPageQuery] = useState({
    page: 0,
    size: 7,
    nombrePage: 1,
    pagePagination: 1,
  });
  const [loadingData, setLoadingData] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [snackbarSuccessOpen, setSnackbarOpenSuccess] = useState(false);
  const [snackbarErrorOpen, setSnackbarOpenError] = useState(false);
  const [snackbarPosition, setSnackbarPosition] = useState({
    vertical: "bottom",
    horizontal: "center",
  });
  const [searchLoading, setSearchLoading] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [desactiveLoading, setDesactiveLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [niveauListe, setNiveauListe] = useState([]);
  const [niveauCategorieListe, setNiveauCategorieListe] = useState([]);
  const [categorieListe, setCategorieListe] = useState([]);
  const [niveauInfo, setNiveauInfo] = useState(null);
  const [serviceData, setNiveauData] = useState({
    id: "",
    niveauId: "",
    categorieId: ""
  });

  const { vertical, horizontal } = snackbarPosition;

  const searchNiveau = () => {
    setLoadingData(true);
    getListeNiveauEtudePagination(pageQuery.page, pageQuery.size, searchTerm)
      .then((res) => {
        setLoadingData(false);
        setNiveauListe(res.data.donnee.niveaux);
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.donnee.totalPages,
        }));
      })
      .catch((err) => {
        setLoadingData(false);
        console.log("api error", err);
      });
  };

  const modalCreateNiveau = () => {
    setNiveauInfo(null);
    setNiveauData({
      id: "",
      niveauId: "",
      categorieId: ""
    });
  };

  const modalEditNiveau = (niveau) => {
    document.getElementById("ajout-niveau").click();
    setNiveauInfo(niveau);
    setNiveauData({
      id: niveau.id,
      niveauId: niveau.id,
      categorieId: ""
    });
  };

  // liste des niveaux enregistrés par l'établissement
  const getListeDesNiveaux = () => {
    setLoadingData(true);
    getListeNiveauEtudePagination(0, pageQuery.size)
      .then((res) => {
        setLoadingData(false);
        setNiveauListe(res.data.donnee.niveaux);
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.donnee.totalPages,
        }));
      })
      .catch((err) => {
        setLoadingData(false);
        console.log("api error", err);
      });
  };

  // récupère la liste des niveaux selon la catégorie
  const getListeDesNiveauxParCategorie = (categorieId) => { 
    setNiveauData((prevState) => ({
      ...prevState,
      categorieId: categorieId,
    }))
    getListeNiveauParCategorie(categorieId)
      .then((res) => {
        setNiveauCategorieListe(res.data.donnee);
      })
      .catch((err) => {
        console.log("api error", err);
      });
  };

  const getListeDesCategorie = () => {
    getListeCategorie()
      .then((res) => {
        setCategorieListe(res.data.donnee);
      })
      .catch((err) => {
        console.log("api error", err);
      });
  }

  const ajoutNouveauNiveau = () => {
    setAddLoading(true);

    const newNiveau = {
      categorieId: serviceData.categorieId,
      id: serviceData.niveauId
    }

    ajoutNiveauEtude(newNiveau)
      .then((res) => {
        setSuccessMessage("Niveau enregistré avec succès");
        setSnackbarOpenSuccess(true);
        setAddLoading(false);
        document.getElementById("ajout-niveau").click();
        getListeDesNiveaux();
      })
      .catch((err) => {
        setAddLoading(false);
        if (err && err.response) {
          setErrorMessage(err.response.data.donnee);
          setSnackbarOpenError(true);
        } else {
          setErrorMessage("Erreur d'enregistrement, rééssayer!");
          setSnackbarOpenError(true);
        }
        console.log("api error", err);
      });
  };

  const supprimerNiveau = () => {
    setDeleteLoading(true);

    deleteNiveauEtude(niveauInfo.id)
      .then((res) => {
        setSuccessMessage("Niveau supprimé avec succès");
        getListeDesNiveaux();
        getListeDesNiveauxParCategorie();
        setSnackbarOpenSuccess(true);
        setDeleteLoading(false);
        document.getElementById("delete-warning").click();
      })
      .catch((err) => {
        setDeleteLoading(false);
        if (err.response.data) {
          setErrorMessage(err.response.data.donnee);
          setSnackbarOpenError(true);
        } else {
          setErrorMessage("Une erreur s'est produite, rééssayer!");
          setSnackbarOpenError(true);
        }
        console.log("api error", err);
      });
  };

  const handleCloseSnackbarSuccess = () => {
    setSnackbarOpenSuccess(false);
  };

  const handleCloseSnackbarError = () => {
    setSnackbarOpenError(false);
  };

  const handlePaginationChange = (event, value) => {
    setLoadingData(true);
    setPageQuery((prev) => ({
      ...prev,
      page: value,
      pagePagination: value,
    }));
    if (searchTerm.length !== 0) {
      getListeNiveauEtudePagination(value - 1, pageQuery.size)
        .then((res) => {
          setNiveauListe(res.data.donnee.niveaux);
          setPageQuery((prev) => ({
            ...prev,
            nombrePage: res.data.donnee.totalPages,
          }));
          setLoadingData(false);
        })
        .catch((err) => {
          setLoadingData(false);
          console.log("api error", err);
        });
    } else {
      getListeNiveauEtudePagination(value - 1, pageQuery.size, searchTerm)
        .then((res) => {
          setNiveauListe(res.data.donnee.niveaux);
          setPageQuery((prev) => ({
            ...prev,
            nombrePage: res.data.donnee.totalPages,
          }));
          setLoadingData(false);
        })
        .catch((err) => {
          setLoadingData(false);
          console.log("api error", err);
        });
    }
  };

  const TableElement = ({ niveau }) => {
    return (
      <tr>
        <td className="px-4">{niveau.categorie ? niveau.categorie.designation : ""}</td>
        <td className="px-4">{niveau.designation}</td>
        <td className="w-40 px-4">
          <div className="flex items-center gap-x-3">
            <button
              className="bg-gray-100 p-1 rounded-md text-gray-700 cursor-pointer"
              onClick={() => {
                document.getElementById("delete-warning").click();
                setNiveauInfo(niveau);
              }}
            >
              <DeleteIcon />
            </button>
            <button
              className="bg-gray-100 p-1 rounded-md text-gray-700 cursor-pointer"
              onClick={() => modalEditNiveau(niveau)}
            >
              <EditIcon />
            </button>
          </div>
        </td>
      </tr>
    );
  };

  useEffect(() => {
    setLoadingData(true);
    getListeDesCategorie()
    getListeNiveauEtudePagination(pageQuery.page, pageQuery.size)
      .then((res) => {
        setLoadingData(false);
        setNiveauListe(res.data.donnee.niveaux);
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.donnee.totalPages,
        }));
      })
      .catch((err) => {
        setLoadingData(false);
        console.log("api error", err);
        if (err.response && err.response.status === 401) {
          localStorage.removeItem("momo4scoohclient")
          navigate("/login")
        }
      });
  }, []);

  return (
    <BaseLayout>
      <div className="w-10/12 mx-auto pt-32">
        <h1 className="text-2xl text-black font-bold">
          Paramètre / Niveaux d'étude
        </h1>
        <div className="mt-10 pb-16">
          <div className="mb-5 flex items-center justify-between">
            <div>
              <p>Rechercher</p>
              <div className="flex items-center gap-x-2">
                <input
                  type="text"
                  disabled={searchLoading}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="Rechercher un élément"
                  className="input input-bordered w-full max-w-xs"
                />
                <button
                  disabled={searchLoading}
                  className="w-14 h-11 bg-stone-900 text-white rounded-md flex items-center justify-center"
                  onClick={searchNiveau}
                >
                  {!searchLoading ? (
                    <SearchIcon />
                  ) : (
                    <TailSpin
                      height="25"
                      width="25"
                      color="#fff"
                      ariaLabel="tail-spin-loading"
                      radius="1"
                      wrapperStyle={{}}
                      wrapperClass=""
                      visible={searchLoading}
                    />
                  )}
                </button>
              </div>
            </div>
            <label
              htmlFor="ajout-niveau"
              className="bg-momo-blue text-white px-3 py-2 rounded-lg font-medium cursor-pointer"
              onClick={modalCreateNiveau}
            >
              Ajouter un niveau
            </label>
          </div>
          <div className="overflow-x-auto">
            <table className="table table-compact w-full mb-2">
              <thead>
                <tr>
                  <th className="capitalize py-4 px-4">Type d'enseignement</th>
                  <th className="capitalize py-4 px-4">Designation</th>
                  <th className="capitalize py-4 px-4">Actions</th>
                </tr>
              </thead>
              <tbody>
                {!loadingData && niveauListe.length > 0 ? (
                  niveauListe.map((item) => (
                    <TableElement key={item.id} niveau={item} />
                  ))
                ) : !loadingData && niveauListe.length === 0 ? (
                  <tr>
                    <td colSpan="3">
                      <div className="w-full h-32 bg-white rounded-br-lg rounded-bl-lg flex gap-x-2 text-red-500 items-center justify-center">
                        <ErrorOutlineIcon />
                        <p className="font-medium text-red-500">
                          Aucun élément trouvé
                        </p>
                      </div>
                    </td>
                  </tr>
                ) : loadingData && niveauListe.length === 0 ? (
                  <tr>
                    <td colSpan="3">
                      <div className="w-full h-32 bg-white rounded-br-lg rounded-bl-lg flex gap-x-2 text-red-500 items-center justify-center">
                        <TailSpin
                          height="50"
                          width="50"
                          color="#000"
                          ariaLabel="tail-spin-loading"
                          radius="1"
                          wrapperStyle={{}}
                          wrapperClass=""
                          visible={loadingData}
                        />
                      </div>
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td colSpan="3">
                      <div className="w-full h-32 bg-white rounded-br-lg rounded-bl-lg flex gap-x-2 text-red-500 items-center justify-center">
                        <TailSpin
                          height="50"
                          width="50"
                          color="#000"
                          ariaLabel="tail-spin-loading"
                          radius="1"
                          wrapperStyle={{}}
                          wrapperClass=""
                          visible={loadingData}
                        />
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="flex justify-end">
              <Pagination
                count={pageQuery.nombrePage}
                page={pageQuery.pagePagination}
                variant="outlined"
                shape="rounded"
                onChange={handlePaginationChange}
              />
            </div>
          </div>
        </div>
      </div>

      {/* MODAL AJOUT SERVICE */}
      <input type="checkbox" id="ajout-niveau" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box">
          <h3 className="font-bold text-lg">
            {niveauInfo === null
              ? "Ajouter un niveau d'étude"
              : "Modifier ce niveau d'étude"}
          </h3>
          <div className="py-4">
            <div>
              <label className="label">
                <span className="label-text">Type d'enseignement</span>
              </label>
              <select
                disabled={addLoading}
                value={serviceData.categorieId}
                onChange={(e) => getListeDesNiveauxParCategorie(e.target.value)}
                className="select select-bordered w-full font-medium"
              >
                <option value="" disabled selected>
                  Choisir une catégorie
                </option>
                {categorieListe.map((item, index) => (
                  <option value={item.id} key={index}>
                    {item.designation}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="label">
                <span className="label-text">Niveau d'étude</span>
              </label>
              <select
                disabled={addLoading}
                value={serviceData.niveauId}
                onChange={(e) =>
                  setNiveauData((prevState) => ({
                    ...prevState,
                    niveauId: e.target.value,
                  }))
                }
                className="select select-bordered w-full font-medium"
              >
                <option value="" disabled selected>
                  Choisir un niveau
                </option>
                {niveauCategorieListe.map((item, index) => (
                  <option value={item.id} key={index}>
                    {item.designation}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="modal-action">
            {!addLoading ? (
              <label
                htmlFor="ajout-niveau"
                className="bg-black text-white font-bold px-4 py-2 rounded-md cursor-pointer"
              >
                Annuler
              </label>
            ) : (
              <label
                htmlFor="ajout-niveau"
                className="bg-black text-white font-bold px-4 py-2 rounded-md pointer-events-none"
              >
                Annuler
              </label>
            )}
            <button
              disabled={addLoading}
              className="bg-momo-jaune text-black font-bold px-4 py-2 rounded-md"
              onClick={ajoutNouveauNiveau}
            >
              {!addLoading ? (
                <span>{!niveauInfo ? "Enregistrer" : "Modifier"}</span>
              ) : (
                <ThreeDots
                  height="20"
                  width="40"
                  radius="9"
                  color="#000"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={addLoading}
                />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* SUPPRIMER SERVICE */}
      <input type="checkbox" id="delete-warning" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box">
          <h3 className="font-bold text-2xl text-center text-red-500">
            Attention !
          </h3>
          <p className="text-lg text-center py-4">
            Cette action est irréversible
          </p>
          <div className="modal-action flex justify-center gap-x-5">
            {!deleteLoading ? (
              <label
                id="delete-warning-btn"
                htmlFor="delete-warning"
                className="bg-gray-300 text-black font-bold px-4 py-2 rounded-md cursor-pointer"
              >
                Annuler
              </label>
            ) : (
              <label
                htmlFor="delete-warning"
                className="bg-gray-300 text-black font-bold px-4 py-2 rounded-md pointer-events-none"
              >
                Annuler
              </label>
            )}
            <button
              disabled={deleteLoading}
              className="bg-red-500 text-white font-bold px-4 py-2 rounded-md flex items-center justify-center"
              onClick={supprimerNiveau}
            >
              {!deleteLoading ? (
                <span>Supprimer</span>
              ) : (
                <ThreeDots
                  height="20"
                  width="40"
                  radius="9"
                  color="#fff"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={deleteLoading}
                />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* SNACKBAR SUCCESS */}
      {successMessage ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={snackbarSuccessOpen}
          autoHideDuration={2000}
          onClose={handleCloseSnackbarSuccess}
          key={vertical + horizontal}
        >
          <div className="bg-green-500 text-white px-10 py-3 rounded-lg">
            {successMessage}
          </div>
        </Snackbar>
      ) : null}

      {/* SNACKBAR ERROR */}
      {errorMessage ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={snackbarErrorOpen}
          autoHideDuration={2000}
          onClose={handleCloseSnackbarError}
          key={vertical + horizontal}
        >
          <div className="bg-red-500 text-white px-10 py-3 rounded-lg">
            {errorMessage}
          </div>
        </Snackbar>
      ) : null}
    </BaseLayout>
  );
};

export default NiveauEtude;
